import CryptoJS from "crypto-js";

// Bazı kurumlar öğrenci/öğretmen ayrımını kendi tarafında (hangi SSO adresine
// yönlendirdiklerini seçerek) yapıyor — ama hepsi yapmıyor. role_type=teacher, öğrenci
// ucuna (ör. /kidzwonder, /hexagonia) düşerse platformun kendi öğrenci sitesine
// göndermek yerine buradan UESPortals'a yönlendiriyoruz. UESPortals.vue'nun kendi
// goUESPortals()'ıyla BİREBİR aynı payload şekli (classes: "grade-branch,grade-branch"
// comma-join) — tek kaynaktan, iki bileşende kopyalanmasın diye burada.
export function redirectToUesPortals(userData, secretKey) {
  const teacherData = {
    school_id: userData.school_id,
    campus_id: userData.campus_id,
    campus_name: userData.campus_name,
    first_name: userData.first_name,
    last_name: userData.last_name,
    username: userData.username,
    roleType: userData.role_type,
    classes: userData.class
        .map(item => `${item.grade}-${item.branch}`)
        .join(","),
  };

  const textJson = JSON.stringify(teacherData);
  const uriText = decodeURIComponent(textJson);
  const ciphertext = CryptoJS.AES.encrypt(uriText, secretKey).toString();

  location.href = "https://www.uesportals.com/#/login/signin?sso=" + btoa(ciphertext);
}
